module.exports = __webpack_public_path__ + "img/3cb-1p-re-no-st.4a531752.png";